/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Copy_DescriptionInputs */



/**
* | output |
* | --- |
* | "Copy this pattern and customize it to create your own custom pattern." |
*
* @param {Compliance_Template_Copy_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_copy_description = /** @type {((inputs?: Compliance_Template_Copy_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Copy_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopieren Sie dieses Muster und passen Sie es an, um Ihr eigenes benutzerdefiniertes Muster zu erstellen.")
	return /** @type {LocalizedString} */ ("Copy this pattern and customize it to create your own custom pattern.")
});